import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const SUBCATEGORIES = [
  ["silk", "Silk Press & Natural Hair"],
  ["mens", "Men's Styles"],
  ["sewins", "Sew-Ins & Specialty Styles"],
  ["color", "Color Services"],
  ["glam", "Makeup, Lashes & Brows"],
  ["addons", "Add-Ons"],
];

const bookService = (id) => {
  trackEvent("booking_click", { event_label: id, item_id: id });
  window.location.href = `/?service=${id}#booking`;
};

const BeautyServicesSection = ({ services }) => {
  const beauty = services.filter((s) => s.category === "beauty");
  if (beauty.length === 0) return null;
  const wednesday = beauty.find((s) => s.id === "svc-hb-silk-press-wednesday");

  return (
    <div className="mt-20" data-testid="beauty-services-section">
      <p className="text-xs uppercase tracking-[0.3em] font-sans text-brand-gold text-center mb-3">Beyond Braids</p>
      <h3 className="font-serif text-2xl md:text-3xl text-brand-text text-center mb-2">Additional Hair &amp; Beauty Services</h3>
      <p className="font-sans text-sm text-brand-text-muted text-center mb-8">Silk press, sew-ins, color, glam &amp; more — tap any row to book</p>

      {wednesday && (
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          onClick={() => bookService(wednesday.id)}
          data-testid="wednesday-special-banner"
          className="block w-full max-w-3xl mx-auto mb-10 border-2 border-brand-gold bg-brand-gold/10 hover:bg-brand-gold/20 transition-colors p-5 text-center group"
        >
          <span className="inline-flex items-center gap-2 font-sans text-[10px] uppercase tracking-[0.25em] text-brand-gold mb-2">
            <Sparkles size={12} /> Special Promotion <Sparkles size={12} />
          </span>
          <span className="block font-serif text-xl md:text-2xl text-brand-text">
            Wednesday Silk Press Special — <span className="text-brand-gold font-bold">$60</span>
          </span>
          <span className="block font-sans text-xs text-brand-text-muted mt-1.5">
            Every Wednesday only · regularly $85 · tap to book your spot
          </span>
        </motion.button>
      )}

      {SUBCATEGORIES.map(([key, label]) => {
        const rows = beauty.filter((s) => s.subcategory === key);
        if (rows.length === 0) return null;
        return (
          <div key={`beauty-${key}`} className="max-w-5xl mx-auto mb-10" data-testid={`beauty-group-${key}`}>
            <h4 className="font-serif text-lg text-brand-gold mb-3 border-b border-brand-gold/30 pb-2">{label}</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10">
              {rows.map((s) => (
                <button
                  key={`beauty-row-${s.id}`}
                  onClick={() => bookService(s.id)}
                  data-testid={`beauty-row-${s.id}`}
                  className="flex items-center gap-3 py-2.5 border-b border-brand-border/40 hover:border-brand-gold/60 text-left group transition-colors"
                >
                  <span className="font-sans text-sm text-brand-text flex-1 group-hover:text-brand-gold transition-colors">
                    {s.name}
                    {s.id === "svc-hb-silk-press-wednesday" && (
                      <span className="ml-2 font-sans text-[9px] uppercase tracking-wider bg-brand-gold text-black px-1.5 py-0.5 font-bold">Wed Special</span>
                    )}
                  </span>
                  <span className="font-sans text-base text-brand-gold font-bold whitespace-nowrap">${s.starting_price}</span>
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BeautyServicesSection;
